import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../RoutingAuth/auth.service';

@Component({
	selector: 'app-support-callback',
	template: '',

})
export class SupportCallbackComponent implements OnInit {


	constructor(private authService: AuthService) { }

	async ngOnInit() {
		var thisHolder = this;
		thisHolder.authService.clearUserInfo().then(() => {
			thisHolder.authService.configData.goHome();
		});
	}
}
